import { render, staticRenderFns } from "./CelularesView.vue?vue&type=template&id=f3668fe6&scoped=true&"
import script from "./CelularesView.vue?vue&type=script&lang=js&"
export * from "./CelularesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3668fe6",
  null
  
)

export default component.exports